module.exports = __webpack_public_path__ + "img/left-lightning9.9c75a6c4.png";